<template lang="pug">
.general
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h2.primary--text {{ $t('Order.general') }}
    v-row
      v-col.d-flex.align-center
        h3.primaryHover--text {{ $t('Order.info') }}
    v-row
      v-col
        v-text-field(
          :value="instance.businessScope && instance.businessScope.path",
          :label="$tc('BusinessScope._name', 1)",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.externalId",
          :label="$t('Order.externalId')",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.bundleKey",
          :label="$t('Order.bundleKey')",
          disabled,
        )
      v-col
        app-datetime-picker(
          :value="instance.createdAt",
          :label="$t('Order.createdAt')",
          disabled,
        )
      v-col
        app-datetime-picker(
          :value="instance.modifiedAt",
          :label="$t('Order.modifiedAt')",
          disabled,
        )
    v-row
      v-col
        v-text-field(
          v-model="instance.shipperReference",
          :label="$t('Order.shipperReference')",
          :error-messages="errors['order.shipperReference']",
          :error="!!errors['order.shipperReference']"
        )
      v-col
        v-text-field(
          v-model="instance.receiverReference",
          :label="$t('Order.receiverReference')",
          :error-messages="errors['order.receiverReference']",
          :error="!!errors['order.receiverReference']"
        )
      v-col
        v-select(
          :label="$t('Order.status')",
          :items="orderStatuses",
          item-text="name",
          item-value="id",
          :loading="statusLoading",
          v-model="instance.statusId",
          )
    v-row
      v-col
        v-text-field(
          v-model="instance.incotermCode",
          :label="$t('Order.incotermCode')",
          :error-messages="errors['order.incotermCode']",
          :error="!!errors['order.incotermCode']"
        )
      v-col
        v-text-field(
          v-model="instance.incotermLocation",
          :label="$t('Order.incotermLocation')",
          :error-messages="errors['order.incotermLocation']",
          :error="!!errors['order.incotermLocation']"
        )
      v-col
        v-text-field(
          v-model="instance.transportMode",
          :label="$t('Order.transportMode')",
          :error-messages="errors['order.transportMode']",
          :error="!!errors['order.transportMode']"
        )
  .entity-content.pa-5
    v-row
      v-col.d-flex.align-center
        h3.primaryHover--text {{ $t('User.information')}}
    v-row
      v-col
        v-text-field(
          :value="instance.user ? instance.user.fullName : ''",
          :label="$t('User.fullName')",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.user ? instance.user.email : ''",
          :label="$t('User.email')",
          disabled,
        )
      v-col
        v-text-field(
          :value="instance.user ? instance.user.phoneNumber : ''",
          :label="$t('User.phoneNumber')",
          disabled,
        )
</template>

<script>
import EntityMixin from '@/mixins';
import axios from 'axios';

export default {
  mixins: [EntityMixin],
  props: {
    slotProps: null,
    loading: null,
    uid: null,
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    orderStatuses: [],
    statusLoading: true,
  }),
  async created() {
    try {
      this.orderStatuses = (await axios.get('Status?where[]=entity="Order"', { params: { pageSize: -1 } })).data.data;
    } catch (error) {
      console.log(this.$cleanString(error));
    } finally {
      this.statusLoading = false;
    }
  },
}
</script>
